import { constants } from '../constants/fichaContactologica.constants';


export const getGraduacionesContactologicas = (pacienteId: string) => ({
  type: constants.GET_GRADUACIONES_CONTACT_REQUEST,
  payload: { pacienteId },

});
export const getDatosFichaContactologica = (codigo: string, tiendaGraduacion: string) => ({
  type: constants.GET_GRADUACION_CONTACTOLOGICA_REQUEST,
  payload: { codigo, tiendaGraduacion },
});
export const getDatosUltimaOptometria = (codigo: string) => ({
  type: constants.GET_GRADUACION_ULTIMA_OPTOMETRIA_REQUEST,
  payload: { codigo },
});

export const guardarDatosFichaContactologica = (data:any) => ({
  type: constants.GUARDAR_GRADUACION_CONTACTOLOGICA_REQUEST,
  payload: data,
});
